// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__2-zbu","imgBanner":"Banner_imgBanner__3n5vu"};